import { FormItemProps, FormProps } from "antd";

export const discountCodeFormLayout: Pick<
  FormProps,
  "labelCol" | "wrapperCol"
> = {
  wrapperCol: {
    xs: { span: 0 },
    md: { span: 8 },
    xl: { span: 6 },
    xxl: { span: 5 },
  },
  labelCol: {
    xs: { span: 0 },
    md: { span: 10 },
    xl: { span: 6 },
    xxl: { span: 5 },
  },
};

export const discountCodeEventsFieldLayout: Pick<FormItemProps, "wrapperCol"> =
  {
    wrapperCol: {
      xs: { span: 0, push: 0 },
      md: { span: 8, push: 10 },
      xl: { span: 6, push: 6 },
      xxl: { span: 5, push: 5 },
    },
  };
